module.exports = ".title span{color:black}.title span.content{font-style:italic;color:#5E6974}\n"